import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import './amplify.config';
import { environment } from './environments/environment';

console.log(`[Angular App] Loaded environment stage: ${environment.stage}, Cognito Domain: ${environment.cognitoDomainPrefix}, Asset API: ${environment.assetManagementApiUrl}`);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
